import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function LandingPage() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  function handleSearch(e) {
    e.preventDefault();
    if (!query.trim()) return;
    const q = query.trim();
    const isDomain = q.includes('.') && !q.includes(' ');
    if (isDomain) {
      navigate(`/domain/overview?domain=${encodeURIComponent(q)}`);
    } else {
      navigate(`/keywords/overview?keyword=${encodeURIComponent(q)}`);
    }
  }

  const tools = [
    { icon: '◧', title: 'Domain Overview', desc: 'Comprehensive domain analysis with authority score, organic traffic and keyword insights', color: '#FF642D', to: '/domain/overview' },
    { icon: '◫', title: 'Organic Research', desc: 'Discover competitor organic keywords, rankings and top performing pages', color: '#2962FF', to: '/domain/organic' },
    { icon: '⌕', title: 'Keyword Overview', desc: 'In-depth keyword analysis with volume, difficulty, CPC and SERP data', color: '#00C853', to: '/keywords/overview' },
    { icon: '✦', title: 'Keyword Magic Tool', desc: 'Generate thousands of relevant keyword ideas from a single seed keyword', color: '#7C4DFF', to: '/keywords/magic' },
    { icon: '⬙', title: 'Keyword Gap', desc: 'Identify valuable keywords your competitors rank for that you are missing', color: '#FFAB00', to: '/keywords/gap' },
    { icon: '🔗', title: 'Backlink Analytics', desc: 'Detailed backlink profile analysis with referring domains and authority metrics', color: '#00B8D4', to: '/backlinks/overview' },
    { icon: '⧉', title: 'Backlink Gap', desc: 'Find high-quality backlink opportunities from your competitor profiles', color: '#FF3D57', to: '/backlinks/gap' },
    { icon: '◍', title: 'Site Audit', desc: 'Complete technical SEO audit with 130+ checks and actionable recommendations', color: '#651FFF', to: '/audit/site' },
    { icon: '◎', title: 'On-Page Checker', desc: 'Optimize any page for your target keyword with data-driven suggestions', color: '#37474F', to: '/audit/onpage' },
  ];

  return (
    <div className="landing">
      <header className="landing-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 32, height: 32, background: '#FF642D', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800 }}>S</div>
          <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: '0.05em' }}>SUNGRESH</span>
        </div>
        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
          <Link to="/free-seo-tools" className="lp-nav-link" style={{ fontSize: 13, fontWeight: 500, color: '#37474F', textDecoration: 'none' }}>Tools</Link>
          <Link to="/blog" className="lp-nav-link" style={{ fontSize: 13, fontWeight: 500, color: '#37474F', textDecoration: 'none' }}>Blog</Link>
          <Link to="/pricing" style={{ fontSize: 13, fontWeight: 600, color: '#111', textDecoration: 'none' }}>Pricing</Link>
          <Link to="/dashboard" className="btn btn-black btn-sm">Dashboard</Link>
        </div>
      </header>

      <style>{`
        .lp-hero{max-width:1200px;margin:0 auto;padding:56px 24px 48px;display:grid;grid-template-columns:1.1fr 1fr;gap:48px;align-items:center}
        .lp-hero h1{font-size:46px;line-height:1.08;font-weight:800;letter-spacing:-0.02em;margin:0 0 16px;color:#111}
        .lp-hero h1 span{color:#FF642D}
        .lp-hero .lp-sub{font-size:16px;line-height:1.6;color:#4B5563;margin:0 0 24px;max-width:520px}
        .lp-free{background:#FAFAFA;border:1px solid #E5E7EB;border-radius:14px;padding:20px}
        .lp-free-head{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:14px}
        .lp-free-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .lp-free-card{display:block;background:#fff;border:1px solid #E5E7EB;border-radius:10px;padding:12px 14px;text-decoration:none;color:#111;transition:border-color .15s,transform .15s}
        .lp-free-card:hover{border-color:#FF642D;transform:translateY(-1px)}
        .lp-free-card b{display:block;font-size:13px;margin-bottom:3px}
        .lp-free-card small{font-size:11.5px;color:#6B7280;line-height:1.4}
        @media (max-width: 900px){.lp-hero{grid-template-columns:1fr;gap:28px;padding-top:36px}.lp-hero h1{font-size:34px}}
        @media (max-width: 560px){.lp-nav-link{display:none}.landing-header{gap:12px}}
        @media (max-width: 340px){.lp-free-grid{grid-template-columns:1fr}}
        @media (max-width: 420px){.lp-free-card{padding:10px 11px}.lp-free-card small{display:none}}
      `}</style>

      <div className="lp-hero">
        <div>
          <div style={{ display: 'inline-flex', background: '#F3F4F6', border: '1px solid #E5E7EB', borderRadius: 99, padding: '6px 14px', fontSize: 11, fontWeight: 600, marginBottom: 18, gap: 6, alignItems: 'center', color: '#37474F' }}>
            <span style={{ width: 6, height: 6, background: '#00C853', borderRadius: '50%' }}></span>
            FREE SEO TOOLS • 15 FREE CREDITS • NO CARD NEEDED
          </div>
          <h1>Free SEO Tools<br/><span>for Growing Websites</span></h1>
          <p className="lp-sub">Keyword research, backlink analysis, rank checks and site audits with real DataForSEO data. Start free, upgrade only when you need more.</p>

          <form onSubmit={handleSearch} style={{ maxWidth: 560 }}>
            <div className="semrush-search">
              <input
                className="search-input"
                value={query}
                onChange={e => setQuery(e.target.value)}
                placeholder="Enter a domain or keyword (e.g. nike.com or running shoes)"
                aria-label="Domain or keyword"
              />
              <button className="search-btn" type="submit">
                Analyze
              </button>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
              {['nike.com', 'best SEO tools', 'nytimes.com', 'ai writing'].map(ex => (
                <button key={ex} type="button" onClick={() => setQuery(ex)} style={{ background: '#F3F4F6', border: '1px solid #E5E7EB', borderRadius: 99, padding: '4px 10px', fontSize: 11, cursor: 'pointer', color: '#6B7280' }}>
                  {ex}
                </button>
              ))}
            </div>
          </form>

          <div style={{ display: 'flex', gap: 28, marginTop: 28, flexWrap: 'wrap' }}>
            <div><div style={{ fontWeight: 800, fontSize: 18 }}>15</div><div style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>Free credits</div></div>
            <div><div style={{ fontWeight: 800, fontSize: 18 }}>20+</div><div style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>Free tools</div></div>
            <div><div style={{ fontWeight: 800, fontSize: 18 }}>$0</div><div style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>To start</div></div>
          </div>
        </div>

        <div className="lp-free">
          <div className="lp-free-head">
            <div>
              <div style={{ display: 'inline-block', background: '#FFF1EB', color: '#FF642D', fontSize: 10.5, fontWeight: 800, letterSpacing: '0.08em', padding: '3px 8px', borderRadius: 99, marginBottom: 6 }}>FREE • NO SIGNUP</div>
              <div style={{ fontSize: 19, fontWeight: 800, color: '#111', letterSpacing: '-0.01em' }}>Try a free SEO tool</div>
            </div>
            <Link to="/free-seo-tools" style={{ fontSize: 12, fontWeight: 600, color: '#FF642D', textDecoration: 'none' }}>All tools →</Link>
          </div>
          <div className="lp-free-grid">
            {[
              { to: '/keyword-difficulty-checker', t: 'Keyword Difficulty', d: 'How hard is it to rank?' },
              { to: '/backlink-checker', t: 'Backlink Checker', d: 'Links & referring domains' },
              { to: '/google-rank-checker', t: 'Google Rank Checker', d: 'Where does a site rank?' },
              { to: '/ai-detector', t: 'AI Content Detector', d: 'Was this written by AI?' },
              { to: '/meta-tag-generator', t: 'Meta Tag Generator', d: 'Titles & descriptions' },
              { to: '/page-speed-checker', t: 'Page Speed Checker', d: 'Load time & Core Web Vitals' },
            ].map(f => (
              <Link key={f.to} to={f.to} className="lp-free-card">
                <b>{f.t}</b>
                <small>{f.d}</small>
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px 80px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ fontWeight: 800, fontSize: 20 }}>Professional SEO Toolkit</h2>
          <Link to="/dashboard" className="btn btn-white btn-sm">Open Dashboard</Link>
        </div>
        
        <div className="tools-grid">
          {tools.map(tool => (
            <Link key={tool.to} to={tool.to} className="tool-card">
              <div className="tool-icon" style={{ background: `${tool.color}15`, color: tool.color }}>{tool.icon}</div>
              <div className="tool-title">{tool.title}</div>
              <div className="tool-desc">{tool.desc}</div>
            </Link>
          ))}
        </div>

        <div style={{ marginTop: 48, background: '#111', color: 'white', borderRadius: 12, padding: 32, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12, lineHeight: 1.2 }}>Enterprise SEO Tools<br/>at Startup Pricing</h3>
            <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>Professional-grade SEO platform powered by enterprise data providers. Comprehensive toolkit for agencies, marketers, and growing businesses seeking measurable organic growth.</p>
            <div style={{ display: 'flex', gap: 12 }}>
              <Link to="/dashboard" className="btn" style={{ background: '#FF642D', color: 'white' }}>Start Free Trial</Link>
              <Link to="/pricing" className="btn" style={{ background: 'white', color: 'black' }}>View Pricing</Link>
            </div>
          </div>
          <div style={{ background: '#1F1F1F', borderRadius: 8, padding: 16, border: '1px solid #2A2A2A' }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#666', marginBottom: 12 }}>Sample report (illustrative)</div>
            <div style={{ fontFamily: 'JetBrains Mono', fontSize: 11, color: '#A0A0A0', lineHeight: 1.6 }}>
              {`{`}
              <br/>&nbsp;&nbsp;"domain": "example.com",
              <br/>&nbsp;&nbsp;"authorityScore": 92,
              <br/>&nbsp;&nbsp;"organicTraffic": 42350000,
              <br/>&nbsp;&nbsp;"keywords": 1250000,
              <br/>&nbsp;&nbsp;"backlinks": "85.3M",
              <br/>&nbsp;&nbsp;"refDomains": "450K"
              <br/>{`}`}
            </div>
          </div>
        </div>

        <div style={{ marginTop: 64, borderTop: '1px solid #E5E7EB', paddingTop: 32, display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 32, fontSize: 13 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
              <div style={{ width: 28, height: 28, background: '#FF642D', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800, fontSize: 14 }}>S</div>
              <span style={{ fontWeight: 800, fontSize: 14 }}>SUNGRESH</span>
            </div>
            <p style={{ color: '#6B7280', lineHeight: 1.6, fontSize: 12 }}>Professional SEO platform for marketers, agencies, and businesses. Real-time data, comprehensive toolkit, affordable pricing.</p>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tools</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/keyword-research-tool" style={{ color: '#6B7280', textDecoration: 'none' }}>Keyword Research</Link>
              <Link to="/backlink-checker" style={{ color: '#6B7280', textDecoration: 'none' }}>Backlink Checker</Link>
              <Link to="/site-audit-tool" style={{ color: '#6B7280', textDecoration: 'none' }}>Site Audit</Link>
              <Link to="/free-seo-tools" style={{ color: '#6B7280', textDecoration: 'none' }}>All Tools</Link>
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Resources</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/blog" style={{ color: '#6B7280', textDecoration: 'none' }}>Blog</Link>
              <Link to="/blog/best-semrush-alternative-2024" style={{ color: '#6B7280', textDecoration: 'none' }}>SEMrush Alternative</Link>
              <Link to="/blog/ai-search-optimization-guide" style={{ color: '#6B7280', textDecoration: 'none' }}>AI Search Guide</Link>
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Company</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/pricing" style={{ color: '#6B7280', textDecoration: 'none' }}>Pricing</Link>
              <Link to="/dashboard" style={{ color: '#6B7280', textDecoration: 'none' }}>Dashboard</Link>
              <Link to="/privacy" style={{ color: '#6B7280', textDecoration: 'none' }}>Privacy Policy</Link>
              <Link to="/terms" style={{ color: '#6B7280', textDecoration: 'none' }}>Terms of Service</Link>
              <span style={{ color: '#9CA3AF', fontSize: 11, marginTop: 8 }}>© 2026 Sungresh. All rights reserved.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
